import { Button } from '@mui/material';
import React from 'react';
import { SercomTypes } from '../support/sercom-types';

const SercomButton = (props: SercomTypes.SercomButton) => {
  return (
    <Button
      color={props.isDestructive ? 'error' : 'primary'}
      variant={props.variant}
      disabled={props.disabled ?? false}
      onClick={props.onClick}
      sx={{ px: 2.25, py: .9, borderRadius: 2, textTransform: 'none', fontWeight: 700, boxShadow: 'none' }}
    >
      {props.text}
    </Button>
  );
};

export default SercomButton;
